import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import { Button, Input, Icon, Typography, Dropdown, Menu, Tooltip, message } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { platformApi } from "../../../api";
import DistrictTable from "./DistrictTable";
import DistrictForm from "./DistrictForm";
import { ContextAPI } from "../../../ContextAPI";

const { Search } = Input;
const { Title } = Typography;
const { Item } = Menu;

const District = (props) => {
  const { loginCredintials } = useContext(ContextAPI);
  const [createAccess, setCreateAccess] = useState(true);
  const [modifyAccess, setModifyAccess] = useState(true);

  const [searchString, setSearchString] = useState("");
  const [districts, setDistricts] = useState([]);
  const [count, setCount] = useState(0);
  const [spinner, setSpinner] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editable, setEditable] = useState(true);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  const getMenu = () => {
    let size = count / 10 + (count % 10 ? 1 : 0);
    const menus = [];
    menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item onClick={() => { setLimit(menu); setPage(1); }} key={menu}>
        {menu}
      </Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;

  useEffect(() => {
    if (loginCredintials && loginCredintials.roleAccess) {
      loginCredintials.roleAccess.forEach((each) => {
        if (each.subModule === "district") {
          if (each.access && each.access.create !== undefined) {
            setCreateAccess(each.access.create);
          }
          if (each.access && each.access.update !== undefined) {
            setModifyAccess(each.access.update);
          }
        }
      });
    }
  }, [loginCredintials]);

  useEffect(() => {
    fetchDistricts(page, limit, searchString);
  }, [page, limit, searchString]);

  const fetchDistricts = (p, l, search) => {
    setSpinner(true);
    platformApi
      .post("/api/csc/district/get", {
        page: p,
        size: l,
        searchString: search,
      })
      .then((res) => {
        setSpinner(false);
        const { data } = res;
        if (data.code === 200) {
          const { response } = data;
          if (response && response.code === 200 && response.data) {
            setDistricts(response.data.districts || []);
            setCount(response.data.count || 0);
          }
        }
      })
      .catch((err) => {
        setSpinner(false);
        console.error("Error fetching districts:", err);
        message.error("Failed to fetch districts");
      });
  };

  const openModal = (id, isEditable = true) => {
    if (id) {
      const selected = districts.find((item) => item.id === id);
      setCurrentRecord(selected || null);
    } else {
      setCurrentRecord(null);
    }
    setEditable(isEditable);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentRecord(null);
  };

  const emitData = (payload) => {
    if (payload.id) {
      platformApi
        .put(`/api/csc/district/${payload.id}`, payload)
        .then((res) => {
          if (res.data && res.data.code === 200) {
            message.success("District updated successfully");
            fetchDistricts(page, limit, searchString);
          } else {
            message.error(res.data?.message || "Failed to update district");
          }
        })
        .catch((err) => {
          console.error("Error updating district:", err);
          message.error("Error updating district");
        });
    } else {
      platformApi
        .post("/api/csc/district", payload)
        .then((res) => {
          if (res.data && res.data.code === 200) {
            message.success("District created successfully");
            setPage(1);
            fetchDistricts(1, limit, searchString);
          } else {
            message.error(res.data?.message || "Failed to create district");
          }
        })
        .catch((err) => {
          console.error("Error creating district:", err);
          message.error("Error creating district");
        });
    }
  };

  const deleteData = (id) => {
    let temp = page !== 1 && districts.length === 1;
    platformApi
      .delete(`/api/csc/district/${id}`)
      .then((res) => {
        if (res.data && res.data.code === 200) {
          message.success("District deleted successfully");
          if (temp) {
            setPage(1);
            fetchDistricts(1, limit, searchString);
          } else {
            fetchDistricts(page, limit, searchString);
          }
        } else {
          message.error(res.data?.message || "Failed to delete district");
        }
      })
      .catch((err) => {
        console.error("Error deleting district:", err);
        message.error("Error deleting district");
      });
  };

  return (
    <div>
      <div className="supplierMaster-top" style={{ display: "flex", alignItems: "center", marginBottom: "1.25rem" }}>
        <Title style={{ width: "60%" }} level={4}>
          <Tooltip placement="topLeft" title={"Back to Company Master"}>
            <Button
              style={{ margin: "0 20px" }}
              onClick={() => props.history.push("/autoadmin/company")}
            >
              <LeftOutlined />
            </Button>
          </Tooltip>
          District Master[{count}]
          <span style={{ marginLeft: "1rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit}
                &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          placeholder="Search District"
          style={{ width: "30%" }}
          onSearch={(event) => {
            setPage(1);
            setSearchString(event);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearchString("");
              setPage(1);
            }
          }}
        />
        <Button
          type="primary"
          className="add-manufacturer-button"
          onClick={() => openModal(null, true)}
          style={{ margin: "0 3%", width: "14%" }}
          disabled={!createAccess}
        >
          Add District
        </Button>
      </div>

      <div style={{ margin: ".5rem" }}>
        <DistrictTable
          dataSource={districts}
          spinner={spinner}
          pagination={{
            onChange: (p) => {
              setPage(p);
            },
            pageSize: limit,
            defaultCurrent: 1,
            total: count,
            current: page,
            showQuickJumper: true,
          }}
          openModal={openModal}
          delete={deleteData}
        />
      </div>

      <DistrictForm
        open={isModalOpen}
        close={closeModal}
        data={currentRecord}
        editable={editable}
        modify={modifyAccess}
        emitData={emitData}
      />
    </div>
  );
};

export default withRouter(District);
